import React, { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { DataTable } from "primereact/datatable";
import {
  defaultPageRowOptions,
  defaultRowOptions,
  gstAddedStatusDropdown,
  paginatorLinks,
  PaymentModeSubContractorDropdown,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
  SubContractorPaymentDropdown,
} from "../../appconfig/Settings";
import { Column } from "primereact/column";
import { SubContractorPaymentListColumn } from "../../appconfig/DatatableSetting";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteData, getAllDetails, getDetails, postAllData, postDataByID, updateData } from "../../service/ProductService";
import {
  DELETE_SUB_CONTRACTOR_PAYMENT_INVOICE,
  GET_INVOICE_LIST,
  GET_INVOICE_PAYEE_LIST,
  GET_SUB_CONTRACTOR_LIST,
  GET_SUB_CONTRACTOR_PAYMENT_LIST,
  PAYMENT_RECEIVED_DATE,
  SEND_EMAIL_AND_UPDATE_STATUS,
  SEND_PAYMENT_EMAIL_BULK_SUBCONTRACTOR,
  SEND_PAYMENT_EMAIL_SUBCONTRACTOR,
  UPDATE_SUB_CONTRACTOR_PAYMENT_STATUS,
} from "../../config/ApiConstant";
import { createContractorTemplate, dateTemplate, dateTemplateWithoutUtc, nameTemplate } from "../../appconfig/TemplateFieldSetting";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { Badge } from "primereact/badge";
import { convertDateFrom } from "../../appconfig/AppHelper";
import { validatePaymentReceived } from "../../config/Validate";
import SubContractorTab from "./SubContractorTab";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import Loader from "../../components/Loader/Loader";

// mail sent filter options
const mailStatusDropdown = [
  { name: "Mail Sent", value: true },
  { name: "Mail Not Sent", value: false },
];

const SubContractorPayment = () => {
  document.title = "SubContractor Payment | Nexawage ";

  const navigate = useNavigate();

  // const { id } = useParams();
  // const clientParamId = id ? atob(id) : null;

  // get client id fron navigation state
  const location: any = useLocation();
  const clientParamId = location?.state?.clientId;

  const toast = useRef<any>(null);

  // loading
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // invoice list and selected row
  const [selectedRowId, setSelectedRowId] = useState<any>(null);
  const [paymentList, setPaymentList] = useState<any>([]);

  // selected row
  const [selectedRow, setSelectedRow] = useState<any>(null);

  // Delete dialog
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false);

  // errors obj
  const [errors, setErrors] = useState<any>({});

  //   filter
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

  // selected payee
  const [selectedSubContractor, setSelectedSubContractor] = useState<Number | null>(null);

  // payee Dropdown
  const [subContractorDropdown, setSubContractorDropdown] = useState<any>([]);

  // confirmation dialog
  const [emailSendDialog, setEmailSendDialog] = useState<boolean>(false);

  // bulk selection and bulk email dialog
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [bulkEmailDialog, setBulkEmailDialog] = useState<boolean>(false);

  // regenerate pdf doalig
  const [reGeneratePdfDialog, setReGeneratePdfDialog] = useState<any>();

  // period End or e-transfer date range selected
  const [rangeDropdownSelected, setRangeDropdownSelected] = useState<any>(null);

  // total anual amount
  const [totalAmount, setTotalAmount] = useState<any>(null);

  // payment status dialog
  const [paymentStatusDialog, setPaymentStatusDialog] = useState<boolean>(false);
  const [paymentStatus, setPaymentStatus] = useState<any>(null);
  const [isHold, setIsHold] = useState<any>(null);
  const [paymentDate, setPaymentDate] = useState<Date | null | string | any>();

  //   gst added status
  const [gstAddedStatus, setGstAddedStatus] = useState<any>(null);

  // payment mode filter template
  const [paymentMode, setPaymentMode] = useState<any>(null);

  // Date states
  let today = new Date();
  const [etransferStartDate, setEtransferStartDate] = useState<string | Date | Date[] | any | null>(null);

  let todayDate = new Date();
  // invoice dates
  const [periodStartDate, setPeriodStartDate] = useState<string | Date | Date[] | any | null>(new Date(todayDate.setDate(today.getDate() - 31)));

  // payment received range end date
  const [etransferEndDate, setEtransferEndDate] = useState<string | Date | any | null>(null);

  // invoice end date
  const [periodEndDate, setPeriodEndDate] = useState<string | Date | any | null>(new Date());

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";

  // filter
  const emptyFilters = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    gst_added: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    date: {
      operator: FilterOperator.OR,
      constraints: [
        {
          value: null,
          matchMode: FilterMatchMode.DATE_IS,
        },
      ],
    },
    payment_mode: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    send_mail: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    payment_date: {
      operator: FilterOperator.OR,
      constraints: [
        {
          value: null,
          matchMode: FilterMatchMode.DATE_IS,
        },
      ],
    },
  };
  const [filters, setFilters] = useState(emptyFilters);

  // client id based on login
  let clientId: any = null;
  if (userRole === "User") {
    clientId = clientParamId;
  } else {
    clientId = userData?.id;
  }

  // useEffect to get invoice list and payee details
  useEffect(() => {
    getPaymentList();
    getSubContractorNameAndDetail();
  }, [selectedSubContractor, etransferStartDate, periodStartDate, etransferEndDate, periodEndDate]);

  // get payment  list api call
  const getPaymentList = async () => {
    try {
      setPageLoad(false);
      const response = await getDetails(
        `${GET_SUB_CONTRACTOR_PAYMENT_LIST}/${clientId}?sub_contractor_id=${selectedSubContractor}&payment_start_date=${!window.cn(etransferStartDate) ? convertDateFrom(etransferStartDate) : ""
        }&payment_end_date=${!window.cn(etransferEndDate) ? convertDateFrom(etransferEndDate) : ""}&start_date=${!window.cn(periodStartDate) ? convertDateFrom(periodStartDate) : ""
        }&end_date=${!window.cn(periodEndDate) ? convertDateFrom(periodEndDate) : ""}`,
      );

      // normalise date — append T00:00:00 (no tz) so new Date parses as local midnight, not UTC
      const normalized = response?.data?.map((item: any) => ({
        ...item,
        date: item.date ? new Date(item.date.substring(0, 10) + "T00:00:00") : null,
        payment_date: item?.payment_date ? new Date(item?.payment_date.substring(0, 10) + "T00:00:00") : null,

        // searchable strings for global filter
        date_search: item.date ? moment(item.date).format("DD MMM YYYY") : "",
        payment_date_search: item?.payment_date ? moment(item?.payment_date).format("DD MMM YYYY") : "",
      }));

      setPaymentList(normalized);
      setTotalAmount(response?.totalAmount);
      setPageLoad(true);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // get payee name using api call
  const getSubContractorNameAndDetail = async () => {
    try {
      const response = await getAllDetails(`${GET_SUB_CONTRACTOR_LIST}/${clientId}`);

      if (response) {
        const DataList = response;
        if (DataList.length === 0) {
          setSubContractorDropdown([]);
        } else {
          const DataList = response.map((item: any) => ({
            name: `${item?.name}`,
            value: item?.id,
          }));
          setSubContractorDropdown(DataList);
        }
      }
    } catch (error) { }
  };

  // api call for payment received date
  const paymentReceived = async () => {
    try {
      const { errors, isError } = validatePaymentReceived(paymentDate);
      setErrors(errors);
      if (isError) return;
      setSubmitLoading(true);

      const payload = {
        payment_date: paymentDate,
      };

      const response = await updateData(UPDATE_SUB_CONTRACTOR_PAYMENT_STATUS, selectedRowId, payload);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response?.message,
        });
        hidePaymentStatusDialog();
        getPaymentList();
      }
    } catch (error: any) {
      toast.current.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.error,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // on payment date change
  const onDateChange = (e: any) => {
    let val;
    let dateVal;
    val = e?.terget?.value ?? e?.value;
    dateVal = moment(val).format("YYYY-MM-DD");
    setPaymentDate(dateVal);
    setErrors({});
  };

  // input payment received date handler
  const onEtransferDateChange = (e: any) => {
    setEtransferStartDate(e.value);
    setPeriodStartDate(null);
  };

  const onEtransferEndDateChange = (e: any) => {
    setEtransferEndDate(e.value);
    setPeriodEndDate(null);
  };

  // invoice date change dropdown
  const onPeriodStartDateChange = (e: any) => {
    setPeriodStartDate(e.value);
    setEtransferStartDate(null);
  };

  const onPeriodEndDateChange = (e: any) => {
    setPeriodEndDate(e.value);
    setEtransferEndDate(null);
  };

  // clear all fields
  const ClearAll = () => {
    setFilters({ ...emptyFilters });
    setGlobalFilter(null);
    setGlobalFieldFilter(null);
    setSelectedSubContractor(null);
    setEtransferStartDate(null);
    setEtransferEndDate(null);
    setPeriodStartDate(new Date(new Date().setDate(new Date().getDate() - 31)));
    setPeriodEndDate(new Date());
    setRangeDropdownSelected(null);
  };

  // open payment status dialog
  const onPaymentStatusChange = (rowData: any, e: any) => {
    setPaymentStatusDialog(true);
    setSelectedRowId(rowData?.id);
    setPaymentStatus(e?.target?.value);
  };

  // hide payment status dialog
  const hidePaymentStatusDialog = () => {
    setPaymentStatusDialog(false);
    setSelectedRowId(null);
    setPaymentDate(null);
    setErrors({});
  };

  // global search filter on change
  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilter(value);
  };

  //   left toolbar template
  const leftToolbarTemplate = () => (
    <>
      <span className="block mr-2 p-input-icon-left">
        <i className="pi pi-search" />
        {/* <InputText type="search" value={globalFilter || ""} onChange={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." /> */}
        <InputText type="search" value={globalFilter || ""} onChange={onGlobalFilterChange} placeholder="Search..." />
      </span>

      <Dropdown
        id="subContractor"
        value={selectedSubContractor}
        onChange={(e) => setSelectedSubContractor(e.value)}
        options={subContractorDropdown}
        optionLabel="name"
        placeholder="Select Sub Contractor"
        name="selectedSubContractor"
        className=" w-16rem ml-3"
      ></Dropdown>
    </>
  );

  //   right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <div className="p-toolbar-group-right-invoice">
        {/* dropdown to select date range */}
        <Dropdown
          id="dateRange"
          value={rangeDropdownSelected}
          onChange={(e) => setRangeDropdownSelected(e.value)}
          options={SubContractorPaymentDropdown}
          optionLabel="name"
          placeholder="Select Period or E-Transfer Date Range"
          name="rangeDropdownSelected"
          className=" w-18rem ml-3"
        ></Dropdown>

        {/* calendar based on period or e-transfer date range */}
        {rangeDropdownSelected === "Period End Date Range" ? (
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <label className="label-text mb-2">Select Period End Date From</label>
              <div>
                <Calendar
                  value={periodStartDate}
                  onChange={(e) => onPeriodStartDateChange(e)}
                  readOnlyInput
                  dateFormat="dd/mm/yy"
                  placeholder="Select Date From"
                  showIcon
                  className="w-16rem ml-2 p-0.5rem"
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <label className="label-text mb-2">Select Period End Date To</label>
              <div>
                <Calendar
                  value={periodEndDate}
                  onChange={(e) => onPeriodEndDateChange(e)}
                  readOnlyInput
                  dateFormat="dd/mm/yy"
                  placeholder="Select Date To"
                  showIcon
                  className="w-16rem ml-2 p-0.5rem"
                />
              </div>
            </div>
          </div>
        ) : rangeDropdownSelected === "E-Transfer Date Range" ? (
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <label className="label-text mb-2">Select E-Transfer Date Range From</label>
              <div>
                <Calendar
                  value={etransferStartDate}
                  onChange={(e) => onEtransferDateChange(e)}
                  readOnlyInput
                  dateFormat="dd/mm/yy"
                  placeholder="Select Date From"
                  showIcon
                  className="w-16rem ml-2"
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <label className="label-text mb-2">Select E-transfer Date Range To</label>
              <div>
                <Calendar
                  value={etransferEndDate}
                  onChange={(e) => onEtransferEndDateChange(e)}
                  readOnlyInput
                  dateFormat="dd/mm/yy"
                  placeholder="Select Date To"
                  showIcon
                  className="w-16rem ml-2"
                />
              </div>
            </div>
          </div>
        ) : null}

        <div style={{ display: "flex", alignItems: "end" }}>
          {selectedRows.length > 0 && (
            <Button
              icon="pi pi-envelope"
              label={`Send Email (${selectedRows.length})`}
              onClick={() => setBulkEmailDialog(true)}
              className="ml-3 common-primary-button"
            />
          )}
          <Button icon="pi pi-filter-slash" label="Clear" onClick={ClearAll} className="mr-3 ml-3 p-button-outlined common-p-outline-button" />
        </div>

        {/* <Button
        label="Create New Invoice"
        icon="pi pi-plus"
        className="p-button-primary"
        onClick={() => navigate("/invoice")}
      /> */}
      </div>
    </>
  );

  // view pdf
  const viewPdf = (rowData: any) => {
    if (rowData.url) {
      window.open(rowData.url, "_blank");
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "PDF NOT FOUND",
      });
    }
  };

  // invoice pdf body template
  const invoicePdfTemplate = (rowData: any) => (
    <>
      <div className="actions">
        <Button
          icon="pi pi-file-pdf"
          tooltip="View Invoice"
          className="p-button-secondary common-view-pdf-btn"
          tooltipOptions={{ position: "bottom" }}
          onClick={() => viewPdf(rowData)}
        />
      </div>
    </>
  );

  // payment status template
  const paymentStatusTemplate = (rowData: any) => {
    let statusClass: any = rowData.payment_status === "Pending" ? "danger" : "success";
    return (
      <div className="actions flex flex-column align-items-center">
        <InputSwitch
          className="mr-2 mb-2"
          value={paymentStatus}
          disabled={rowData?.payment_status === "Completed"}
          checked={rowData?.payment_status === "Pending" ? false : true}
          onChange={(e) => onPaymentStatusChange(rowData, e)}
        />
        <Badge
          severity={statusClass}
          value={rowData.payment_status === "Completed" ? "Received" : "Pending"}
          style={{ width: "fit-content" }}
        ></Badge>
      </div>
    );
  };

  // cycle status filter template
  const gstAddedStatusFilterTemplate = (options: any) => {
    return (
      <Dropdown
        // filter
        value={gstAddedStatus}
        onChange={(e: any) => {
          setGstAddedStatus(e.value);
          options.filterCallback(e.value ? e.value : null, options.index);
        }}
        options={gstAddedStatusDropdown}
        optionLabel="name"
        placeholder="Status"
        className="order-drp"
      ></Dropdown>
    );
  };

  // cycle status template
  const gstAddedStatusTemplate = (rowData: any) => {
    const amount = rowData.net_amount ? `$${rowData?.net_amount}` : "-";
    return (
      <div>
        {rowData?.gst_added === true && <Badge severity="success" value="Gst Inc." style={{ width: "fit-content" }} />}
        <p>{amount}</p>
      </div>
    );
  };

  // date filter template
  const dateFilterTemplate = (options: any) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterApplyCallback(e.value)}
        dateFormat="dd/mm/yy"
        placeholder="Select Date"
        showIcon
      />
    );
  };

  const pdfTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-file-pdf"
        tooltip="View PDF"
        className="p-button-secondary common-view-pdf-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => viewPdf(rowData)}
      />
    </div>
  );

  // amount template
  const amountTemplate = (rowData: any) => {
    let gstStatusClass: any = rowData?.gst_added === true ? "Included" : "Excluded";
    if (rowData?.amount) {
      return (
        <div>
          <span style={{ fontSize: "12px" }}>
            {gstStatusClass} <br />
          </span>
          <span>{rowData?.amount}</span>
        </div>
      );
    }
  };

  // gst amount template
  const gstAmountTemplate = (rowData: any) => {
    const gst_amount = rowData.gst_amount ? `$${rowData?.gst_amount}` : "-";
    return <div className="actions">{gst_amount}</div>;
  };

  // open dialogdialog
  const confirmantionEmailDialog = async (rowData: any) => {
    setEmailSendDialog(true);
    setSelectedRowId(rowData?.id);
    setSelectedRow(rowData);
  };

  // hide email modal
  const hideEmailDialog = () => {
    setEmailSendDialog(false);
    setSubmitLoading(false);
    setSelectedRow(null);
  };

  // update email status api call
  const sendEmail = async () => {
    try {
      setSubmitLoading(true);
      const response = await postDataByID(SEND_PAYMENT_EMAIL_SUBCONTRACTOR, selectedRowId);
      if (response) {
        getPaymentList();
        hideEmailDialog();
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // bulk email api call
  const sendBulkEmail = async () => {
    try {
      setSubmitLoading(true);
      const payload = { ids: selectedRows.map((row: any) => row.id) };
      const response = await postAllData(SEND_PAYMENT_EMAIL_BULK_SUBCONTRACTOR, payload);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hideBulkEmailDialog();
        setSelectedRows([]);
        getPaymentList();
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // hide bulk email modal
  const hideBulkEmailDialog = () => {
    setBulkEmailDialog(false);
    setSubmitLoading(false);
  };

  // delete confirmation modal
  const confirmDelete = (deleteID: any) => {
    setSelectedRowId(deleteID);
    setDeleteDialog(true);
  };

  // delete employee api call
  const deleteInvoice = async () => {
    try {
      setSubmitLoading(true);
      const response = await deleteData(DELETE_SUB_CONTRACTOR_PAYMENT_INVOICE, selectedRowId);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: response.message,
        });
        hideDeleteDialog();
        getPaymentList();
        setSubmitLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setSubmitLoading(false);
    }
  };

  // hide delete modal
  const hideDeleteDialog = () => {
    setDeleteDialog(false);
    setSelectedRowId(null);
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        tooltip={rowData?.send_mail === true ? "email send already" : "Send Email"}
        tooltipOptions={{ position: "bottom" }}
        className={`mr-2 ${rowData?.send_mail === true ? "p-button-success" : "common-primary-button"}`}
        icon="pi pi-envelope"
        label=""
        onClick={() => confirmantionEmailDialog(rowData)}
      />

      <Button
        icon="pi pi-pencil"
        tooltip="Edit PDF"
        className="common-edit-btn "
        tooltipOptions={{ position: "bottom" }}
        onClick={() =>
          navigate(`/edit-sub-contractor/${btoa(rowData?.id)}`, {
            state: { id: rowData?.id, sub_contractor_id: rowData?.sub_contractor_id, clientId: clientId },
          })
        }
      />

      <Button
        icon="pi pi-trash"
        tooltipOptions={{ position: "bottom" }}
        className="ml-2 p-button-danger common-delete-btn"
        tooltip="Delete"
        onClick={() => confirmDelete(rowData.id)}
      />
    </div>
  );

  // payment mode filter template
  const paymentModeFilterTemplate = (options: any) => {
    return (
      <Dropdown
        // filter
        value={paymentMode}
        onChange={(e: any) => {
          setPaymentMode(e.value);
          options.filterCallback(e.value ? e.value : null, options.index);
        }}
        options={PaymentModeSubContractorDropdown}
        optionLabel="name"
        placeholder="Status"
        className="order-drp"
      ></Dropdown>
    );
  };

  // mail sent or not filter template (action column)
  const mailSentFilterTemplate = (options: any) => {
    return (
      <Dropdown
        value={options.value ?? null}
        onChange={(e: any) => options.filterApplyCallback(e.value)}
        options={mailStatusDropdown}
        optionLabel="name"
        optionValue="value"
        placeholder="Mail Status"
        showClear
        className="order-drp"
      ></Dropdown>
    );
  };

  return (
    <>
      <AppBreadcrumb currentMenu="Sub Contractor" pageName="Payment" pageTitle="Payment" goToPage={userRole === "User"} />

      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white crud-demo lg:p-2 relative">
            <SubContractorTab index={1} id={clientId} />
            <Toast ref={toast} />

            {paymentList.length > 0 && (
              <div className="flex align-item-center justify-content-center">
                <h4 className="">Total Amount Of Current Year : ${totalAmount?.toFixed(2)}</h4>
              </div>
            )}

            <Toolbar className="gap-3 invoice-right-tab" left={leftToolbarTemplate} right={rightToolbarTemplate} />

            {pageLoad ? (
              <DataTable
                value={paymentList}
                showGridlines
                dataKey="id"
                stripedRows
                globalFilter={globalFilter}
                rows={defaultRowOptions}
                paginator={paymentList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " Payment List"}
                emptyMessage="No Payment List Found"
                // filters={globalFieldFilter}
                // onFilter={(e) => setGlobalFieldFilter(e.filters)}
                filters={filters}
                onFilter={(e: any) => setFilters(e.filters)}
                globalFilterFields={[
                  "invoice_no",
                  "payment_mode",
                  "payment_status",
                  "contractor_data.name",
                  "contractor_data.email",
                  "contractor_data.phone",
                  "date_search",
                  "payment_date_search",
                  "amount",
                  "gst_amount",
                ]}
                removableSort
                responsiveLayout={"scroll"}
                selection={selectedRows}
                onSelectionChange={(e: any) => setSelectedRows(e.value)}
              >
                <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />
                {SubContractorPaymentListColumn.map((col, i) => {
                  if (col.field === "url") {
                    return <Column key={col.field} field={col.field} header={col.header} body={invoicePdfTemplate} />;
                  } else if (col.field === "email") {
                    return <Column key={col.field} field={col.field} header={col.header} sortable body={createContractorTemplate("email")} />;
                  } else if (col.field === "name") {
                    return <Column key={col.field} field={col.field} header={col.header} sortable body={createContractorTemplate("name")} />;
                  } else if (col.field === "phone") {
                    return <Column key={col.field} field={col.field} header={col.header} sortable body={createContractorTemplate("phone")} />;
                  } else if (col.field === "sin_no") {
                    return <Column key={col.field} field={col.field} header={col.header} body={createContractorTemplate("sin_no")} />;
                  } else if (col.field === "gst_no") {
                    return <Column key={col.field} field={col.field} header={col.header} body={createContractorTemplate("gst_no")} />;
                  } else if (col.field === "gst_added") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={gstAddedStatusTemplate}
                      // filter
                      // filterField="gst_added"
                      // filterElement={gstAddedStatusFilterTemplate}
                      />
                    );
                  } else if (col.field === "date") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                        body={dateTemplateWithoutUtc}
                        dataType="date"
                        filter
                        filterElement={dateFilterTemplate}
                      />
                    );
                  } else if (col.field === "payment_mode") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable
                        filterField="payment_mode"
                        filter
                        filterElement={paymentModeFilterTemplate}
                      />
                    );
                  } else if (col.field === "invoice_no") {
                    return <Column key={col.field} field={col.field} header={col.header} sortable />;
                  } else if (col.field === "amount") {
                    return <Column key={col.field} field={col.field} header={col.header} body={amountTemplate} />;
                  } else if (col.field === "gst_amount") {
                    return <Column key={col.field} field={col.field} header={col.header} body={gstAmountTemplate} />;
                  } else if (col.field === "action") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={actionBodyTemplate}
                        filter
                        filterField="send_mail"
                        dataType="boolean"
                        showFilterMatchModes={false}
                        showFilterOperator={false}
                        showAddButton={false}
                        filterElement={mailSentFilterTemplate}
                      />
                    );
                  } else if (col.field === "payment_date") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={dateTemplateWithoutUtc}
                        sortable
                        dataType="date"
                        filter
                        filterElement={dateFilterTemplate}
                      />
                    );
                  } else if (col.field === "payment_status") {
                    return <Column key={col.field} field={col.field} header={col.header} body={paymentStatusTemplate} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {SubContractorPaymentListColumn.map((col, i) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>

      {/* Email Send Dialog */}
      <Dialog
        visible={emailSendDialog}
        style={{ width: "550px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={"Confirmation To Send Email"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" disabled={submitLoading} onClick={hideEmailDialog} />
            <Button label="Send Email" icon="pi pi-check" className="common-primary-button" onClick={sendEmail} loading={submitLoading} />
          </div>
        }
        onHide={hideEmailDialog}
      >
        <p className="text-lg">
          {` Are you sure you want to send email to `} <span className="font-bold">{`${selectedRow?.contractor_data?.email}`}</span>
        </p>
        <div className="grid p-fluid formgrid"></div>
      </Dialog>

      {/* Bulk Email Send Dialog */}
      <Dialog
        visible={bulkEmailDialog}
        style={{ width: "550px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={"Confirmation To Send Bulk Email"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" disabled={submitLoading} onClick={hideBulkEmailDialog} />
            <Button label="Send Email" icon="pi pi-check" className="common-primary-button" onClick={sendBulkEmail} loading={submitLoading} />
          </div>
        }
        onHide={hideBulkEmailDialog}
      >
        <p className="text-lg">
          {`Are you sure you want to send email to `} <span className="font-bold">{selectedRows.length}</span> {`selected sub contractor payment(s)?`}
        </p>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog
        visible={deleteDialog}
        header="Delete Invoice"
        draggable={false}
        className="mx-3 lg:mx-0"
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideDeleteDialog} />
            <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteInvoice} loading={submitLoading} />
          </div>
        }
        onHide={hideDeleteDialog}
      >
        <div className="flex align-items-center justify-content-start">
          <i className="mr-3 pi pi-exclamation-triangle delete-triangle" style={{ fontSize: "2rem" }} />
          <span className="delete-dialog-note">Are you sure you want to delete this Invoice ?</span>
        </div>
      </Dialog>

      {/* payment status dialog */}
      <Dialog
        visible={paymentStatusDialog}
        style={{ width: "450px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={"Payment Date"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="mr-2 p-button-secondary"
              disabled={submitLoading}
              onClick={hidePaymentStatusDialog}
            />
            <Button label="Submit" icon="pi pi-check" className="common-primary-button" onClick={paymentReceived} loading={submitLoading} />
          </div>
        }
        onHide={hidePaymentStatusDialog}
      >
        <div className="grid p-fluid formgrid">
          {/* Date of Payment */}
          <div className="field col-12 md:col-8">
            <label htmlFor="date">Enter Date of Payment Received *</label>
            <div className="input-effect-div">
              <Calendar
                value={paymentDate ? moment(paymentDate, "YYYY-MM-DD").toDate() : null}
                dateFormat="dd/mm/yy"
                placeholder="Enter Date Of Payment"
                onChange={(e) => onDateChange(e)}
                showIcon
                className={errors["paymentDate"] && "p-invalid"}
              />
            </div>
            <small className="p-invalid-txt">{errors["paymentDate"]}</small>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default SubContractorPayment;
